import { Link } from '@tanstack/react-router';
import { useRipple } from '@/hooks/use-ripple.ts';
import type { Installation } from '@/app/pages/installations.ts';

export function InstallationsGrid({items}: { items: Installation[] }) {
  const { ref } = useRipple();
  return (
    <div ref={ref} className="grid md:grid-cols-2 gap-4">
      {items.map((item) => (
        <Link to={`/view-installation/$id`} params={{id: item.id}} viewTransition={true} key={item.src} className="relative overflow-hidden">
          <div
            className="aspect-[4/5] bg-cover bg-center ripple transition-all duration-1000 ease-in-out hover:scale-[1.05]"
            style={{ backgroundImage: `url(${item.src})` }}
          ></div>
        </Link>
      ))}
    </div>
  );
}